// extracted by mini-css-extract-plugin
export default {"component":"Loader_component__UQusT","loader":"Loader_loader__ieDpA","l18":"Loader_l18__PHzWi"};